import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

// import 'react-aspect-ratio/aspect-ratio.css';
import isPropValid from '@emotion/is-prop-valid';
import { useToggle } from '@infl-ts/util-hooks';
import { Box, Chip, Collapse, styled, Typography } from '@mui/material';
import ReactAspectRatio from 'react-aspect-ratio';
import { useTranslation } from 'react-i18next';
import { CloudflareImage } from '../cloudflare-image';
import { Link } from '../link';
import { ResizableCard } from '../resizable-card';
import { TypographyTruncate } from '../typography-truncate';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var getOverlayColour = function getOverlayColour(_ref) {
  var darkOverlay = _ref.darkOverlay,
      primaryOverlay = _ref.primaryOverlay,
      theme = _ref.theme;
  if (primaryOverlay) return theme.palette.primary.main;
  if (darkOverlay) return theme.palette.common.black;
  return theme.palette.common.white;
};

var FullCardLink = styled(Link)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: inherit;\n  text-decoration: none;\n  z-index: ", ";\n\n  &:before {\n    content: ' ';\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n  }\n"])), function (t) {
  return t.theme.zIndex._1;
});
var Overlay = styled(Box, {
  shouldForwardProp: isPropValid
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  &:before {\n    content: ' ';\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    background-image: linear-gradient(transparent, ", ");\n  }\n"])), function (props) {
  return getOverlayColour(props);
});
export var ChannelCard = function ChannelCard(_ref2) {
  var _ref2$channel = _ref2.channel,
      name = _ref2$channel.name,
      description = _ref2$channel.description,
      banner = _ref2$channel.banner,
      newChallengeCount = _ref2$channel.newChallengeCount,
      availableChallengeCount = _ref2$channel.availableChallengeCount,
      usePrimaryColorForOverlay = _ref2$channel.usePrimaryColorForOverlay,
      darkMode = _ref2$channel.darkMode,
      linkTo = _ref2.linkTo,
      _ref2$openInNewTab = _ref2.openInNewTab,
      openInNewTab = _ref2$openInNewTab === void 0 ? false : _ref2$openInNewTab;

  var _useToggle = useToggle(),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      descriptionVisible = _useToggle2[0],
      _useToggle2$ = _useToggle2[1],
      on = _useToggle2$.on,
      off = _useToggle2$.off;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(ReactAspectRatio, {
    ratio: "0.95",
    "data-element": "ReactAspectRatio",
    "data-component": "ChannelCard",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsxs(ResizableCard, {
      sx: {
        minWidth: '230px',
        minHeight: '241px'
      },
      "data-element": "ResizableCard",
      "data-component": "ChannelCard",
      "data-source-file": "index.tsx",
      children: [banner ? /*#__PURE__*/_jsx(CloudflareImage, {
        id: banner.id,
        blurhash: banner.blurhash,
        sx: {
          width: 1,
          height: 1
        },
        alt: name
      }) : /*#__PURE__*/_jsx(Box, {
        sx: {
          background: function background(t) {
            return t.palette.primary.background;
          },
          width: 1,
          height: 1
        }
      }), /*#__PURE__*/_jsx(Overlay, {
        darkOverlay: darkMode,
        primaryOverlay: usePrimaryColorForOverlay,
        "data-element": "Overlay",
        "data-component": "ChannelCard",
        "data-source-file": "index.tsx"
      }), /*#__PURE__*/_jsxs(Box, {
        onMouseOver: on,
        onFocus: on,
        onMouseLeave: off,
        onBlur: off,
        sx: {
          display: 'flex',
          flexDirection: 'column',
          position: 'absolute',
          top: 0,
          right: 0,
          padding: 1,
          height: 1,
          width: 'inherit'
        },
        "data-element": "Box",
        "data-source-file": "index.tsx",
        children: [!!newChallengeCount && newChallengeCount !== 0 && /*#__PURE__*/_jsx(Chip, {
          sx: {
            width: 'fit-content',
            ml: 'auto'
          },
          label: t("{{newChallengeCount}} New", {
            newChallengeCount: newChallengeCount
          }),
          color: "primary",
          size: "small"
        }), /*#__PURE__*/_jsxs(Box, {
          sx: {
            display: 'flex',
            flexDirection: 'column',
            color: function color(t) {
              return darkMode ? t.palette.primary.contrastText : t.palette.text.primary;
            },
            padding: function padding(t) {
              return t.spacing(1);
            },
            mt: 'auto'
          },
          "data-element": "Box",
          "data-source-file": "index.tsx",
          children: [/*#__PURE__*/_jsx(FullCardLink, {
            to: linkTo !== null && linkTo !== void 0 ? linkTo : '',
            target: openInNewTab ? '_blank' : undefined,
            "data-element": "FullCardLink",
            "data-source-file": "index.tsx",
            children: /*#__PURE__*/_jsx(TypographyTruncate, {
              sx: {
                mb: 0.5
              },
              variant: "h4",
              lines: 2,
              "data-element": "TypographyTruncate",
              "data-source-file": "index.tsx",
              children: name
            })
          }), description && /*#__PURE__*/_jsx(Collapse, {
            sx: {
              height: descriptionVisible ? '32px!important' : 0,
              transition: 'height 0.3s ease',
              mb: descriptionVisible ? 3 : 0
            },
            "in": descriptionVisible,
            children: /*#__PURE__*/_jsx(TypographyTruncate, {
              variant: "body2",
              lines: 2,
              dangerouslySetInnerHTML: {
                __html: description
              }
            })
          }), availableChallengeCount ? /*#__PURE__*/_jsx(Typography, {
            variant: "caption",
            children: t('availableChallengeCount', {
              count: availableChallengeCount
            })
          }) : null]
        })]
      })]
    })
  });
};